import React, { useContext } from 'react';
import { useSelector } from 'react-redux';
import PropTypes from 'prop-types';
import { makeStyles } from '@material-ui/core/styles';
import { lighten } from '@material-ui/core/styles/colorManipulator';
import AppBar from '@material-ui/core/AppBar';
import MUIToolbar from '@material-ui/core/Toolbar';
import BackButton from './BackButton';
import Status from './Status';
import FormContext from '../FormContext';
import { getLanguage } from '../../../features/app/selectors';
import { Typography } from '@material-ui/core';
import { useLocation } from 'react-router-dom';

const useStyles = makeStyles(theme => ({
  appBar: {
    position: 'relative', // To make z-index work
    zIndex: theme.zIndex.drawer + 1,
    color: theme.palette.text.primary,
    background: lighten(theme.palette.primary.light, 0.97)
  },
  flex: {
    flexGrow: 1
  }
}));

export function Toolbar({ ContentRight }) {
  const classes = useStyles();
  const location = useLocation();
  const { getDataLabels, data } = useContext(FormContext);
  const language = useSelector(getLanguage);
  const { status } = getDataLabels(language);
  return (
    <div data-testid="form-toolbar">
      <AppBar
        position="static"
        classes={{ root: classes.appBar }}
        elevation={1}
      >
        <MUIToolbar>
          <BackButton />
          <Status>{status}</Status>
          {location.pathname === '/marketSettings' && (
            <Typography variant="h6">Market Settings</Typography>
          )}
          <div className={classes.flex} />
          {ContentRight && <ContentRight data={data} />}
        </MUIToolbar>
      </AppBar>
    </div>
  );
}

Toolbar.propTypes = {
  ContentRight: PropTypes.func
};

export default Toolbar;
